import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import InfoBox from "./InfoBox";
import ForestIcon from "@mui/icons-material/Forest";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import RedeemIcon from "@mui/icons-material/Redeem";

const HowToHelpSection = () => {
  return (
    <Box
      sx={{
        paddingTop: "50px",
        paddingBottom: "50px",
        display: "flex",
        justifyContent: "center",
        borderTop: "1px solid #EEEEEE",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          paddingLeft: {
            xs: "24px",
            md: 0,
          },
          paddingRight: {
            xs: "24px",
            md: 0,
          },
        }}
      >
        <Grid container spacing={4} alignItems="stretch">
          <Grid size={{ xs: 12, md: 6 }}>
            <InfoBox
              title="Donate"
              description="CRI is a non-profit organization. All donations go directly towards research."
              icon={RedeemIcon}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <InfoBox
              title="Help"
              description="See how you can help by volunteering or activism."
              icon={VolunteerActivismIcon}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default HowToHelpSection;
